import { useMemo } from "react";
import INotification from "../interfaces/INotification";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (notifications: INotification[], shape: Shape | Shape[] | null): INotification[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape ? notifications.filter(n => geometryService.isPointInsideShape(n.centerPoint, shape)) : notifications, [notifications, shape]);
}